import * as React from "react";
import { forwardRef } from "react";
const SvgStepError = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M3.33325 3.33325L12.6666 12.6666M3.33325 12.6666L12.6666 3.33325", stroke: "#EA445A", strokeWidth: 1.64, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgStepError);
export default ForwardRef;
